<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          name="code_name"
          :value="employee.code_name"
          :label="$t('EMPLOYEES.ABACUS_CODE_NAME')"
          readonly
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="abacus_id"
          :value="employee.abacus_id"
          :label="$t('EMPLOYEES.ABACUS_NUMBER')"
          readonly
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="type"
          :value="employee.type_id"
          :label="$t('EMPLOYEES.TYPE')"
          readonly
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          name="last_update"
          :value="employee.last_update | dateFormat"
          :label="$t('EMPLOYEES.LAST_UPDATE')"
          readonly
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field
          name="last_update"
          :value="employee.entry_date | dateFormat"
          :label="$t('EMPLOYEES.ENTRY_DATE')"
          readonly
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field
          name="last_update"
          :value="employee.leaving_date | dateFormat"
          :label="$t('EMPLOYEES.LEAVING_DATE')"
          readonly
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'EmployeeAbacusInformationForm',

  filters: {
    dateFormat
  },

  props: {
    employee: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
